import { APP_VERSION } from '../config/constants';

const Info = () => {
    return (
        <div className="version">{APP_VERSION}</div>
    );
}

export default Info;